var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34666 13H4.99999C4.58666 13 4.21999 12.9867 3.89332 12.94C2.13999 12.7467 1.66666 11.92 1.66666 9.66667V6.33333C1.66666 4.08 2.13999 3.25333 3.89332 3.06C4.21999 3.01333 4.58666 3 4.99999 3H7.30666",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34666 13H4.99999C4.58666 13 4.21999 12.9867 3.89332 12.94C2.13999 12.7467 1.66666 11.92 1.66666 9.66667V6.33333C1.66666 4.08 2.13999 3.25333 3.89332 3.06C4.21999 3.01333 4.58666 3 4.99999 3H7.30666",
    stroke: "#b0b8cb",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0133 3H11C11.4133 3 11.78 3.01333 12.1067 3.06C13.86 3.25333 14.3333 4.08 14.3333 6.33333V9.66667C14.3333 11.92 13.86 12.7467 12.1067 12.94C11.78 12.9867 11.4133 13 11 13H10.0133",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0133 3H11C11.4133 3 11.78 3.01333 12.1067 3.06C13.86 3.25333 14.3333 4.08 14.3333 6.33333V9.66667C14.3333 11.92 13.86 12.7467 12.1067 12.94C11.78 12.9867 11.4133 13 11 13H10.0133",
    stroke: "#b0b8cb",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.3335V14.6668",
    stroke: "#b0b8cb",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33334 5.6665V10.3332",
    stroke: "#b0b8cb",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "3972dd496a7eb4312a4cf00aa5deed32.svg";
export { ForwardRef as ReactComponent };